import {
  i18nContainer,
  locationContainer,
  loginContainer,
  statusContainer,
  utils,
  enumContainer,
} from '@wallaby-ui/core';
import {
  applicationContainer,
  agensContainer,
  filterAndSearchContainer,
  filteringContainer,
  listContainer,
  numberRangeContainer,
  medicationsContainer,
  hospitalizationsContainer,
  chartContainer,
} from '@wallaby-ui/document';
import {Reducer, ReducersMapObject} from 'redux';
import {RouterState} from 'redux-first-history';

const staticReducers = {
  ...listContainer.getReducers(
    hospitalizationsContainer.DOCUMENTS_FEATURE_NAME
  ),
  ...listContainer.getReducers(
    hospitalizationsContainer.HOSPITALIZATIONS_FEATURE_NAME
  ),
  ...listContainer.getReducers(hospitalizationsContainer.TIMELINE_FEATURE_NAME),
  [applicationContainer.APPLICATION_REDUCER_STATE_ID]:
    applicationContainer.applicationSlice.reducer,
  ...chartContainer.getReducers(
    hospitalizationsContainer.DIAGNOSIS_LAB_RESULT_CHART
  ),
  [enumContainer.ENUM_REDUCER_STATE_ID]: enumContainer.enumSlice.reducer,
  [agensContainer.AGENS_REDUCER_STATE_ID]: agensContainer.agensSlice.reducer,
  [numberRangeContainer.NUMBER_RANGE_REDUCER_STATE_ID]:
    numberRangeContainer.numberRangeSlice.reducer,
  [medicationsContainer.MEDICATIONS_REDUCER_STATE_ID]:
    medicationsContainer.medicationsSlice.reducer,
  [i18nContainer.I18N_REDUCER_STATE_ID]: i18nContainer.i18nSlice.reducer,
  [locationContainer.LOCATION_REDUCER_STATE_ID]: locationContainer.reducer,
  [loginContainer.LOGIN_REDUCER_STATE_ID]:
    utils.reducerUtils.createFilteredReducer(
      loginContainer.reducer,
      (action) =>
        (action.stateId ?? action.meta?.stateId) ===
        loginContainer.LOGIN_REDUCER_STATE_ID
    ),
  [statusContainer.STATUS_REDUCER_STATE_ID]:
    statusContainer.statusSlice.reducer,
  [filterAndSearchContainer.FILTER_AND_SEARCH_REDUCER_STATE_ID]:
    utils.reducerUtils.createFilteredReducer(
      filterAndSearchContainer.filterAndSearchSlice.reducer,
      (action) =>
        action.stateId ===
        filterAndSearchContainer.FILTER_AND_SEARCH_REDUCER_STATE_ID
    ),
  [filterAndSearchContainer.FILTER_AND_SEARCH_REDUCER_HIERARCHY_STATE_ID]:
    utils.reducerUtils.createFilteredReducer(
      filterAndSearchContainer.filterAndSearchSlice.reducer,
      (action) =>
        action.stateId ===
        filterAndSearchContainer.FILTER_AND_SEARCH_REDUCER_HIERARCHY_STATE_ID
    ),
  [filteringContainer.FILTERING_REDUCER_STATE_ID]:
    utils.reducerUtils.createFilteredReducer(
      filteringContainer.reducer,
      (action) =>
        (action.stateId ?? action.meta?.stateId) ===
        filteringContainer.FILTERING_REDUCER_STATE_ID
    ),
} as const;

const createReducer = (
  routerReducer: Reducer<RouterState>,
  asyncReducers: ReducersMapObject = {}
) => ({
  // This is necessary for typescript to infer correct type (otherwise it just infer object with router property)
  // eslint-disable-next-line no-useless-computed-key
  ['router']: routerReducer,
  ...staticReducers,
  ...asyncReducers,
});

export default createReducer;
